import { createHookStore, STORE_NAMES } from '@namespace/helpers-store';
import { initDeviceStore } from '../utils/initDeviceStore';

export const initialState = initDeviceStore();
// TODO: add type for store
export const useDeviceStore = createHookStore(STORE_NAMES.DEVICE, initialState);
